import { render, staticRenderFns } from "./Header.User.vue?vue&type=template&id=1f1effdd&scoped=true&"
import script from "./Header.User.vue?vue&type=script&lang=ts&"
export * from "./Header.User.vue?vue&type=script&lang=ts&"
import style0 from "./Header.User.vue?vue&type=style&index=0&id=1f1effdd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1effdd",
  null
  
)

export default component.exports